export const API = 'API';
export const API_REQUEST = 'API_REQUEST';
export const API_SUCCESS = 'API_SUCCESS';
export const API_FAILED = 'API_FAILED';
export const API_ERROR = 'API_ERROR';

export const apiSuccess = ({ data, actionType, meta }) => ({
  type: `${actionType} ${API_SUCCESS}`,
  payload: data,
  meta
});

export const apiFailed = ({ response, actionType, meta }) => ({
  type: `${actionType} ${API_FAILED}`,
  payload: response,
  meta
});

export const apiError = ({ error, actionType, meta }) => ({
  type: `${actionType} ${API_ERROR}`,
  payload: error,
  meta
});

export const apiAction = ({
  url = '',
  method = 'GET',
  data = null,
  actionType = '<>',
  responseType = 'json',
  meta = {},
  abortControllerArrRef = null
}) => {

  return {
    type: `${actionType} ${API_REQUEST}`,
    payload: {
      url,
      method,
      data,
      actionType,
      meta,
      responseType,
      abortControllerArrRef
    }
  };
};
